module.exports = __webpack_public_path__ + "static/meadows-676cb5eb8c24c03d884566fdc9965a66.jpg";